import { render, staticRenderFns } from "./delivery-unit.vue?vue&type=template&id=02f697be&"
import script from "./delivery-unit.vue?vue&type=script&lang=js&"
export * from "./delivery-unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports